import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8cbf4ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "selectRadio"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("注：电子面单账号是您用来进行面单充值的账号，如果不知道，可以联系网点查询")
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 1,
  class: "selectRadio"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("注：电子面单账号是您用来进行面单充值的账号，如果不知道，可以联系网点查询")
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "tips" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("注：电子面单账号是您用来进行面单充值的账号，如果不知道，可以联系网点查询")
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("手机号验证")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("密钥验证")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "注：如果没有手机号，或则手机号不对时，请联系网点修改电子面单账号对应的联系人手机号", -1))
const _hoisted_15 = { class: "cross-center" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "cross-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "注：如果不记得密钥，可以联系网点进行咨询", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_reminder = _resolveComponent("reminder")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FormDialog = _resolveComponent("FormDialog")!

  return (_openBlock(), _createBlock(_component_FormDialog, {
    ref: "formDialogRefs",
    title: "电子面单绑定",
    width: "600px",
    labelWidth: "120px",
    formData: _ctx.editFormData,
    rules: _ctx.chooseType == 'flag_select' ? _ctx.rules : _ctx.rules_mobile,
    showErrorToast: false,
    validateOnRuleChange: false,
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.visibleRef) = $event)),
    saveForm: _ctx.saveFormHandle,
    showCancelBtn: _ctx.canClose,
    showClose: _ctx.canClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "快递公司：",
        prop: "expressName"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: _ctx.editFormData.expressName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editFormData.expressName) = $event)),
            filterable: "",
            placeholder: "请选择物流公司",
            class: "express-txt",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectChangeExpress(_ctx.editFormData.expressName)))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      (_ctx.editFormData.expressName === 'SF|顺丰快递')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_form_item, {
              label: "月结账号：",
              prop: "monthCount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.editFormData.monthCount,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editFormData.monthCount) = $event)),
                  placeholder: _ctx.calCurExpress.placeholderMc || '请输入顺丰月结账号'
                }, null, 8, ["modelValue", "placeholder"]),
                _createElementVNode("p", null, [
                  _hoisted_2,
                  _createElementVNode("a", {
                    target: "_blank",
                    href: _ctx.calLocationOrigin + '/helpDetail?id=169',
                    style: {"color":"#006AFF","padding-left":"10px","cursor":"pointer"}
                  }, "查看教程", 8, _hoisted_3)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              "label-width": "0",
              style: {"margin-bottom":"0"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_reminder, {
                  reminderData: 
                  _ctx.calCurExpress.warning
                    ? { information: _ctx.calCurExpress.warning, _href: '', text: '' }
                    : _ctx.reminderDataList[1]
                
                }, null, 8, ["reminderData"])
              ]),
              _: 1
            })
          ]))
        : (_ctx.editFormData.expressName === 'EMS|EMS')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_form_item, {
                label: "大客户号：",
                prop: "bigCustomerNum"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.editFormData.bigCustomerNum,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editFormData.bigCustomerNum) = $event)),
                    placeholder: "请输入大客户号"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("p", null, [
                    _hoisted_5,
                    _createElementVNode("a", {
                      target: "_blank",
                      href: _ctx.calLocationOrigin + '/helpDetail?id=169',
                      style: {"color":"#006AFF","padding-left":"10px","cursor":"pointer"}
                    }, "查看教程", 8, _hoisted_6)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                "label-width": "0",
                style: {"margin-bottom":"0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_reminder, {
                    reminderData: _ctx.reminderDataList[4]
                  }, null, 8, ["reminderData"])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_form_item, {
                label: "电子面单账号：",
                prop: "partnerId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "请输入电子面单账号",
                    modelValue: _ctx.editFormData.partnerId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editFormData.partnerId) = $event)),
                    modelModifiers: { trim: true }
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    (_ctx.newguide)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          target: "_blank",
                          href: _ctx.calLocationOrigin + '/helpDetail?id=169',
                          style: {"color":"#006AFF","padding-left":"10px","cursor":"pointer"}
                        }, "查看教程", 8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              (_ctx.calShowVerifyType)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "验证方式："
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.chooseType,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.chooseType) = $event)),
                        onChange: _ctx.chooseTypeChange
                      }, {
                        default: _withCtx(() => [
                          (_ctx.editFormData.expressName === 'ZTO|中通快递')
                            ? (_openBlock(), _createBlock(_component_el_radio, {
                                key: 0,
                                label: "flag_select"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_radio, {
                            disabled: _ctx.online || _ctx.editFormData.expressName !== 'ZTO|中通快递',
                            label: "flag_input"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12,
                              _createElementVNode("span", null, [
                                _createVNode(_component_el_tooltip, {
                                  content: "仅支持验证线下面单，请先输入面单账号",
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_13
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (['ST|申通快递', 'SURE|速尔快递', 'ZYKD|众邮快递', 'YCKY|远成快运'].includes(_ctx.editFormData.expressName))
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "网点名称：",
                    prop: "siteCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.editFormData.siteCode,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editFormData.siteCode) = $event)),
                        placeholder: "请输入客户归属网点编号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.chooseType == 'flag_select')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (['ZTO|中通快递'].includes(_ctx.editFormData.expressName))
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "网点名称：",
                          prop: "siteCode"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.editFormData.siteCode,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editFormData.siteCode) = $event)),
                              placeholder: "请选择网点",
                              onChange: _ctx.selectChangeSite
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.siteCodeOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.siteCode,
                                    label: item.siteName,
                                    value: item.siteCode
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, {
                      label: "手机号：",
                      prop: "mobile"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          placeholder: "请输入手机号",
                          modelValue: _ctx.editFormData.mobile,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editFormData.mobile) = $event)),
                          modelModifiers: { trim: true }
                        }, null, 8, ["modelValue"]),
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "图形验证码：",
                      prop: "img_code"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_el_input, {
                            placeholder: "请输入图形验证码",
                            modelValue: _ctx.editFormData.img_code,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editFormData.img_code) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("img", {
                            src: _ctx.imgCodeUrl,
                            class: "img_code",
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.initImgCode && _ctx.initImgCode(...args)))
                          }, null, 8, _hoisted_16)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "短信验证码：",
                      prop: "mobile_code"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_el_input, {
                            placeholder: "请输入验证码",
                            modelValue: _ctx.editFormData.mobile_code,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editFormData.mobile_code) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_el_button, {
                            class: "verifyBtn",
                            disabled: _ctx.time !== 60,
                            onClick: _ctx.startVerify
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.time === 60 ? _ctx.btnText : _ctx.time + 's'), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    (['ZTO|中通快递'].includes(_ctx.editFormData.expressName))
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "网点名称：",
                          prop: "siteCode"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.editFormData.siteCode,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editFormData.siteCode) = $event)),
                              placeholder: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.siteCodeOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.siteCode,
                                    label: item.siteName,
                                    value: item.siteCode
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (![
          'ZJS|宅急送',
          'YZKDBG|邮政快递包裹',
          'JD|京东快递',
          'KYSY|跨越速运',
          'SURE|速尔快递',
          'ZYKD|众邮快递',
          'YCKY|远成快运',
          'XFWL|信丰物流'
        ].includes(_ctx.editFormData.expressName))
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 1,
                          label: "输入密钥：",
                          prop: "password"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              placeholder: _ctx.placeholderPass,
                              type: "password",
                              modelValue: _ctx.editFormData.password,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editFormData.password) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _hoisted_18
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.editFormData.expressName === 'SURE|速尔快递')
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 2,
                          label: "收件快递员：",
                          prop: "receiveCourier"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.editFormData.receiveCourier,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editFormData.receiveCourier) = $event)),
                              placeholder: "请输入收件快递员"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.editFormData.expressName === 'XFWL|信丰物流')
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 3,
                          label: "客户平台ID：",
                          prop: "customerPlatformId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.editFormData.customerPlatformId,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editFormData.customerPlatformId) = $event)),
                              placeholder: "请输入客户平台ID"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.editFormData.expressName === 'XFWL|信丰物流')
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 4,
                          label: "客户平台验证码：",
                          prop: "customerPlatformYzm"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.editFormData.customerPlatformYzm,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editFormData.customerPlatformYzm) = $event)),
                              placeholder: "请输入客户平台验证码"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.editFormData.expressName === 'XFWL|信丰物流')
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 5,
                          label: "客户商号ID或仓库ID：",
                          prop: "customerBusinessId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.editFormData.customerBusinessId,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editFormData.customerBusinessId) = $event)),
                              placeholder: "请输入客户商号ID或仓库ID"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 64)),
              _createVNode(_component_el_form_item, {
                "label-width": "0",
                style: {"margin-bottom":"0"}
              }, {
                default: _withCtx(() => [
                  (_ctx.calCurExpress && _ctx.calCurExpress.warning)
                    ? (_openBlock(), _createBlock(_component_reminder, {
                        key: 0,
                        reminderData: { information: _ctx.calCurExpress.warning, _href: '', text: '' }
                      }, null, 8, ["reminderData"]))
                    : (_ctx.editFormData.expressName === 'ZJS|宅急送')
                      ? (_openBlock(), _createBlock(_component_reminder, {
                          key: 1,
                          reminderData: _ctx.reminderDataList[4]
                        }, null, 8, ["reminderData"]))
                      : (_openBlock(), _createBlock(_component_reminder, {
                          key: 2,
                          reminderData: _ctx.reminderDataList[0]
                        }, null, 8, ["reminderData"]))
                ]),
                _: 1
              })
            ]))
    ]),
    _: 1
  }, 8, ["formData", "rules", "visible", "saveForm", "showCancelBtn", "showClose"]))
}